<template>
  <div class="format-address">
    {{ address.name }}, {{ address.addressCo ? address.addressCo + ', ' : '' }} {{ address.addressLine1 }}, {{ address.postalCode }} {{ address.city }}
    <span v-if="isDefault" class="format-address__is-default">({{ t('deliveryAddressIsDefault') }})</span>
  </div>
</template>

<script>
export default {
  props: {
    address: {
      type: Object,
      required: true
    },
    isDefault: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="scss">
.format-address {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.format-address__is-default {
  color: color(text-green);
}
</style>
